module.exports = __webpack_public_path__ + "8f1cf456f4d0e608ed69a9920081aef4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/public-user-accounts/import/import.html
// module id = 2477
// module chunks = 0